/**
 * default.js
 *
 * Version    : 1.0.6
 * Release    : 28-10-2015
 */
(function() {
    window.c24LpRoot = window.c24LpRoot || '/';
    window.c24MobileDevice = true;
    window.c24DeviceOutput = 'mobile';

    $(document).ready(function() {

        window.c24LpCssLoaded.then(function() {

            /**
             * Help text popup
             */
            if ($('.c24HelpIcon').length) {
                $('.c24HelpIcon').click(function () {
                    if ($(this).hasClass('c24Active')) {
                        $(this).parent().next().hide();
                        $(this).removeClass('c24Active');
                    } else {
                        $(this).parent().next().show();
                        $(this).addClass('c24Active');
                    }
                });
                $('.c24HelpInfo .box24Close').click(function () {
                    $(this).parent().hide();
                    $(this).parent().prev().removeClass('c24Active');
                });
            }

            // If an image has no class adds a class
            $('.c24Editor:not(.noCenter) img').each(function () {
                if (!$(this).attr('class')) $(this).addClass('c24Middle');
            });

            // Wraps a div around the image
            const imgs = $('img.c24TopMiddle, img.c24Middle, img.c24BottomMiddle');
            imgs.wrap('<div class="c24CenterImg"></div>');
            imgs.css('float', 'none');
            imgs.css('margin', 'auto');

            const figures = $('figure > div.c24CenterImg').parent().add(
                'figure.c24TopMiddle, figure.c24Middle, figure.c24BottomMiddle');
            figures.wrap('<div class="c24CenterFigure"></div>');
            figures.css('display', 'table');
            figures.css('float', 'none');
            figures.css('margin', 'auto');

            // Wraps a div around the tables
            $('.c24Editor table').wrap('<div class="c24TableScroll"></div>');


            $('.c24TableScroll').each( function() {
                if ($(this).children(
                    '.c24BlueTable, ' +
                                        '.c24BlueTableNew,' +
                                        '.c24BlueTableNewInv,' +
                                        '.c24GrayTable,' +
                                        '.c24TableMobileCompact,' +
                                        '.c24BlueWhiteTable' ).length > 0) {
                    $(this).css({
                        'padding': '0 14px',
                    });
                }
            });

            /**
             * Fixables
             */
            window.c24LpInitializeFixables();

            /**
             * Accordions
             */
            const accordions = $('.c24Accordion, .mod24Accordion');
            if (accordions.length) {
                accordions.c24Accordion();
            }

            /**
             * Endless Scroll
             */
            if ($('.js24AutoPaginate').length && $('.box24Next').length) {
                let offset = 0;
                if ($('.js24PaginateAdjust').length) offset = $('.js24PaginateAdjust').offset().top + $('.js24PaginateAdjust').height();
                $('.c24m-page').jscroll({
                    loadingHtml: '<div class="is-loading"></div>',
                    nextSelector: '.box24Next',
                    contentSelector: '.js24PaginateContainer',
                    autoTriggerUntil: 8,
                    offset: offset,
                    windowheight: false,
                });
            }

            $('.mod24ac form').on('submit', function(e) {

                if ($(this).data('sticky-top') && $('.js24Fixed', $(this)).length > 0) {

                    e.preventDefault();

                    $('html').stop().animate({
                        'scrollTop': 0,
                    });

                    $('.is-loading', $(this)).removeClass('is-loading');
                }
            });
        });
    });
})();
